<ng-container *ngIf="viewType=='MIN'">
  <div class="hpanel-693 margin-bottom-5-693 gs-widget-card">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1" [NameOftheScreen]="'widgets'"></app-common-skeleton>
    <ng-container *ngIf="!loadAPIcall">
      <div class="panel-heading-693 hbuilt-693 widget-header-693 gs-widget-header">
        {{ headerTitle }}
        <span class="refresh-icon-693" title="Refresh" (click)="refreshPeopleMayYouKnow()">
          <ng-icon name="tablerRefresh"></ng-icon>
        </span>
      </div>
      <div class="panel-body-693 widget-content-693 gs-widget-body">
        <div class="row-693">
          <ul class="profile-list-693" *ngIf="UserdataPeople?.length != 0">
            <ng-container *ngFor="let item of UserdataPeople | slice:0:3">
              <app-common-profile-info [userIdInput]="item.userId" [page]="'PeopleMayYouKnow'">
                <ng-container data-toggle="tooltip" data-placement="top" title="Profile Completion" headline1>
                  <span class="user-name-693">{{item.name}}</span>
                </ng-container>
                <ng-container headline2>
                  <span class="user-type-693" title="{{item.typeofuser | titlecase}}">{{item.typeofuser | titlecase}}</span>
                </ng-container>
                <ng-container btn>
                  <button class="btn-primary btn btn-sm" (click)="connect(item)">
                    Connect
                  </button>
                </ng-container>
              </app-common-profile-info>
            </ng-container>
          </ul>

          <button class="gs-743-more-btn" type="button"
                  *ngIf="UserdataPeople?.length > 0"
                  (click)="modelopen(peopleData)">
            View more →
          </button>
        </div>

        <div class="gs-empty" *ngIf="UserdataPeople?.length == 0">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No suggestions yet</div>
          <div class="gs-empty-sub">Get connected with people to see suggestions you may know.</div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<div class="margin-bottom-5 eyeicon-scroll-container" *ngIf="viewType=='MAX'"
     infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="1500" (scrolled)="onScrollDown()">
  <div class="panel-body cardw">
    <div class="row">
      <!-- Initial loading skeletons -->
      <ng-container *ngIf="loadAPIcall && UserdataPeople.length === 0">
        <div class="col-md-3 padding-left-0 padding-right-5 padding-bottom-5" *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8]">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>

      <!-- Data content -->
      <ng-container *ngIf="UserdataPeople.length > 0">
        <div class="col-md-3 padding-left-0 padding-right-5 padding-bottom-5" *ngFor="let item of UserdataPeople; let i = index">
          <app-user-card [userDataInput]="item" [button]="'PRIMARY'" [standard]="true" (handleEvent)="onCardEvent($event)"></app-user-card>
        </div>

        <!-- Loading skeletons when fetching more data -->
        <ng-container *ngIf="loadAPIcall && UserdataPeople.length > 0">
          <div class="col-md-3 padding-left-0 padding-right-5 padding-bottom-5" *ngFor="let n of [1, 2, 3, 4,5,6,7,8]">
            <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
          </div>
        </ng-container>

        <!-- End of content message -->
        <div class="col-sm-12 gs-end-of-list" *ngIf="stopScroll && UserdataPeople?.length > 0" style="text-align: center; padding-top: 1rem;">
          <div class="col-sm-12">
            <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
            <ng-icon name="tablerCircleCheck"></ng-icon>

          </div>
          <div class="col-sm-12">
            <p class="biase">You've reached the bottom of the page</p>
          </div>
        </div>
      </ng-container>
      <div class="col-sm-12" *ngIf="!loadAPIcall && UserdataPeople?.length == 0">
        <div class="gs-empty">
          <span class="gs-empty-icon"><ng-icon name="tablerUsers"></ng-icon></span>
          <div class="gs-empty-title">No suggestions yet</div>
          <div class="gs-empty-sub">People you may know will show up here.</div>
        </div>
      </div>

    </div>
  </div>
</div>





